import React from 'react'
import { Grid } from '@material-ui/core'
import DOMPurify from 'dompurify'

const FroalaEditorView = require('react-froala-wysiwyg/FroalaEditorView').default
interface Props {
    mailHtmlContent: string
}

const addingTargetBlank = (text: string) => {
    return text.replaceAll('<a', '<a target="_blank"')
}

export function FroalaDescription(props: Props) {
    const { mailHtmlContent } = props

    const purified = DOMPurify.sanitize(mailHtmlContent)

    const data = addingTargetBlank(purified)

    return <Grid dir='auto' container direction='row' wrap='nowrap'>
        <Grid item>
            <FroalaEditorView model={data} />
        </Grid>
    </Grid>
}